import { SpacerProps } from './component';

export type SpacerControlsProps = SpacerProps;
